<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_salesPerson') || '业务开发'"
            prop="salesPersonCode"
          >
            <dict-select
              v-model="formData.salesPersonCode"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :selectedLabel.sync="formData.salesPersonName"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_buyer') || '采购跟单'"
            prop="buyerCode"
          >
            <dict-select
              v-model="formData.buyerCode"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :selectedLabel.sync="formData.buyerName"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_skuSalesChannel') || '产品类型'"
            prop="hxSkuSalesChannel"
          >
            <dict-select
              v-model="formData.hxSkuSalesChannel"
              url="/sys/common/dict/system"
              :body="{ dictType: 'hxSkuSalesChannel' }"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              clearable
              filterable
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_orderCust') || '订单客户'"
            prop="custCode"
          >
            <dict-select
              v-model="formData.custCode"
              url="/master/common/dict/customerSelect"
              :placeholder="$l('form_placeholder_orderCust') || '请选择订单客户'"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_PreOrderDate') || '下单日期'"
            prop="preOrderDate"
          >
            <el-date-picker
              v-model="formData.preOrderDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$l('form_label_totalQty') || '产品总数量'">
            <el-input v-model="formData.totalQty" clearable readonly />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_totalAmount') || '采购金额'">
            <el-input v-model="formData.totalAmount" clearable readonly />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_currencyUnit') || '货币单位'"
            prop="currencyUnit"
          >
            <dict-select
              v-model="formData.currencyUnit"
              url="/master/common/dict/biz"
              :body="{ dictType: 'currencyUnit' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_deliveryDate') || '首次交货日期'"
            prop="deliveryDate"
          >
            <el-date-picker
              v-model="formData.deliveryDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$l('form_label_jdOrderType') || '京东订单类型'">
            <el-input
              v-model="formData.jdOrderType"
              clearable
              maxlength="50"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_jdGoodsType') || '京东产品类型'">
            <el-input
              v-model="formData.jdGoodsType"
              maxlength="50"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_jdPcm') || '京东采控经理'">
            <el-input
              v-model="formData.jdPcm"
              maxlength="50"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_jdPm') || '京东产品经理'">
            <el-input
              v-model="formData.jdPm"
              maxlength="50"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$l('form_label_remark') || '订单备注'">
            <el-input
              v-model="formData.remark"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              rows="4"
              maxlength="1000"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import dayjs from 'dayjs'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    hxPreOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      formData: {
        salesPersonCode: '',
        salesPersonName: '',
        buyerCode: '',
        buyerName: '',
        preOrderDate: '',
        currencyUnit: '',
        custCode: '',
      },
      rules: {
        salesPersonCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        buyerCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        preOrderDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],

        hxSkuSalesChannel: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        custCode: [
          {
            required: true,
            message: this.$l('form_placeholder_orderCust') || '请选择订单客户',
            trigger: 'change',
          },
        ],
        deliveryDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        quotedMethod: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],

        currencyUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    ...mapState('admin/user', { userInfo: 'info' }),
  },
  mounted() {
    this.init()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    init() {
      if (this.hxPreOrderCode) {
        this.getData()
        return
      }

      const { userCode, userName, userNameEn } = this.userInfo || {}
      this.formData.salesPersonCode = userCode || ''
      this.formData.salesPersonName = [userNameEn, userName]
        .filter(Boolean)
        .join('-')
      this.formData.buyerCode = userCode || ''
      this.formData.buyerName = [userNameEn, userName].filter(Boolean).join('-')
      this.formData.preOrderDate = dayjs().format('YYYY-MM-DD')
      this.formData.currencyUnit = 'CNY'
    },
    async getData() {
      const res = await this.$api
        .ecomHxPreOrderDetailApi({ hxPreOrderCode: this.hxPreOrderCode })
        .catch(() => null)
      const data = res?.body || {}
      this.formData = { ...data }
      this.$emit('loaded', data)
    },
    async reload() {
      const res = await this.$api
        .ecomHxPreOrderDetailApi({ hxPreOrderCode: this.hxPreOrderCode })
        .catch(() => null)
      const data = res?.body || {}
      const { totalQty, totalAmount } = data
      this.formData = { ...this.formData, totalQty, totalAmount }
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomHxPreOrderSaveApi(this.formData)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      if (this.hxPreOrderCode) {
        this.getData()
        return
      }
      const { hxPreOrderCode, hxPreOrderNo } = body
      this.$router.replace({
        name: 'ecom-hxBiz-preOrder-detail',
        params: { hxPreOrderCode, pageType: 'edit' },
        query: { hxPreOrderNo },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
.side-frame-danger {
  padding: 1px 5px;
  border-left: 3px solid $color-danger;
  height: 20px;
  margin-top: 3px;
}
</style>
